
<template>
    <article class="checkout">
        <div class="center">
            <form v-on:submit.prevent="process">
                <h1 v-if="action === 'login'">Login</h1>
                <h1 v-else-if="action === 'forgot-password'">Forgot password?</h1>
                <h1 v-else-if="action === 'reset-password'">Reset password</h1>
                <h1 v-else>Create account</h1>

                <p v-for="error in errors" class="error">{{ error[0] }}</p>

                <a v-if="action === 'forgot-password'" v-on:click="displayLogin" class="helper">Remembered your password?</a>
                <label v-if="action !== 'reset-password' && action !== 'setup'">
                    Email address
                    <input v-model="account" type="text"/>
                </label>

                <a v-if="action === 'login'" v-on:click="displayForgotPassword" class="helper">Forgot your password?</a>
                <label v-if="action !== 'forgot-password'">
                    Password
                    <input v-model="password" type="password"/>
                </label>

                <label v-if="action === 'reset-password' || action === 'setup'">
                    Password confirmation
                    <input v-model="password_confirmation" type="password"/>
                </label>

                <button type="submit" class="button is-primary" v-on:click="process">
                    <template v-if="action === 'login'">Login</template>
                    <template v-else-if="action === 'forgot-password'">Send reset link</template>
                    <template v-else-if="action === 'reset-password'">Reset password</template>
                    <template v-else>Create account</template>
                </button>
            </form>
        </div>
    </article>
</template>

<script>
    import auth from '../support/Auth';

	export default
    {
        data()
        {
        	return {
                action: this.$route.name,
                account: this.$route.query.email || null,
                errors: {},
                password: null,
                password_confirmation: null,
            };
        },
        methods:
        {
        	reset()
            {
	            this.errors = {};
	            this.password = this.password_confirmation = null;
            },
	        displayLogin()
	        {
		        this.$router.push( { name: 'login' } );
		        this.action = 'login';
		        this.reset();
	        },
            displayForgotPassword()
            {
	            this.$router.push( { name: 'forgot-password' } );
	            this.action = 'forgot-password';
	            this.reset();
            },
            displayShoots()
            {
	            this.$router.push( { name: 'shoots' } );
            },
            process()
            {
            	switch( this.action ) {
                    case 'login': this.login(); break;
                    case 'forgot-password': this.forgotPassword(); break;
                    case 'reset-password': this.resetPassword(); break;
                    case 'setup': this.resetPassword(); break;
                }
            },
            login()
            {
	            auth.login( this.account, this.password ).then( this.displayShoots, errors => this.errors = errors );
            },
	        forgotPassword()
	        {
                auth.forgot( this.account ).then( this.displayLogin, errors => this.errors = errors );
	        },
            resetPassword()
            {
                auth.reset( this.$route.query.token, this.account, this.password, this.password_confirmation ).then( this.displayShoots, errors => this.errors = errors );
            },
        }
	};
</script>
